import httpClient from '@api/httpClient'
import type { PaginatedResponse } from '@models/pagination'
import type {
  User,
  UserFeatures,
  UserFilters,
  UserLookup,
  UserRole,
} from '@models/user'
import { usersUrls } from './constants'

const getUsers = async (filters: UserFilters) => {
  const { data } = await httpClient.get<PaginatedResponse<User>>(
    usersUrls.root,
    {
      params: filters,
    },
  )
  return data
}

const getUser = async (id: number) => {
  const { data } = await httpClient.get<User>(usersUrls.user(id))
  return data
}

const getUserRoles = async (id: number) => {
  const { data } = await httpClient.get<UserRole[]>(usersUrls.userRoles, {
    params: { companyId: id },
  })
  return data
}

interface CreateUserRequestData {
  companyId: number
  companyPartnerId?: number | null
  login: string
  password?: string | null
  role: UserRole
  phone: string
  fullName: string
  companyIds?: number[] | null
  depotIds?: number[] | null
}

const createUser = async (props: Partial<CreateUserRequestData>) => {
  const { data } = await httpClient.post<User>(usersUrls.root, props)
  return data
}

interface UpdateUserRequestData extends Partial<CreateUserRequestData> {
  id: number
}

const updateUser = async ({ id, ...props }: UpdateUserRequestData) => {
  const { data } = await httpClient.put<User>(usersUrls.user(id), props)
  return data
}

const deleteUser = async (id: number) => {
  await httpClient.delete<User>(usersUrls.user(id))
}

const getUserFeatures = async (userId: number) => {
  const { data } = await httpClient.get<UserFeatures>(
    usersUrls.userFeatures(userId),
  )
  return data
}

const updateUserFeatures = async (props: UserFeatures) => {
  const { userId, ...requestData } = props

  const { data } = await httpClient.put<UserFeatures>(
    usersUrls.userFeatures(userId),
    requestData,
  )
  return data
}

const getUsersLookup = async (filters: UserFilters) => {
  const { data } = await httpClient.get<UserLookup[]>(
    usersUrls.usersLookup(filters.companyId),
    {
      params: filters,
    },
  )
  return data
}

export default {
  getUsers,
  getUser,
  createUser,
  updateUser,
  deleteUser,
  getUserRoles,
  getUserFeatures,
  updateUserFeatures,
  getUsersLookup,
}
